import Box from '@mui/material/Box';
import { Button } from 'common/components/Buttons/Button';
import { useCallback, useState } from 'react';
import { SimProductDetailsEditDialog } from './SimProductDetailsEditDialog';

export const SimProductEdit = ({ iccid }: { iccid: string }) => {
  const [editDialogOpen, setEditDialogOpen] = useState(false);

  const handleOnClose = useCallback(() => {
    setEditDialogOpen(false);
  }, []);

  return (
    <Box flex={0} sx={{ display: 'flex', justifyContent: 'end' }}>
      <Button
        variant="secondary"
        onClick={() => {
          setEditDialogOpen(true);
        }}
      >
        Edit
      </Button>
      <SimProductDetailsEditDialog open={editDialogOpen} onClose={handleOnClose} iccid={iccid} />
    </Box>
  );
};
